import { useApiClient } from '@react/lib/api';
import { useInfiniteQuery } from 'react-query';
export function useReportsQuery(_a) {
    var searchTerm = _a.searchTerm, filters = _a.filters;
    var apiClient = useApiClient().resolve;
    return useInfiniteQuery(['superAdminReports', { searchTerm: searchTerm, filters: filters }], function (_a) {
        var pageParam = _a.pageParam;
        return apiClient.getReports({
            page: pageParam,
            query: searchTerm,
            filters: filters
        });
    }, {
        getNextPageParam: function (lastPage, pages) {
            if (lastPage.data.length === 0) {
                return undefined;
            }
            return pages.length + 1;
        }
    });
}
